import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';

import { LockIcon } from '../../icons';

import styles from './_index.module.scss';

interface TabsProps {
  onChange?: (value: number | string) => void;
  options?: Array<{ label: React.ReactNode; value: number | string }>;
  routes?: Array<{
    is_active?: boolean;
    is_locked?: boolean;
    isDisabled?: boolean;
    label: React.ReactNode;
    to: string | { hash?: string; pathname: string; search?: string };
  }>;
  value?: number | string;
  variant?: 'default' | 'rounded';
}

const Tabs = ({ onChange = () => {}, options, routes, value, variant = 'default' }: TabsProps) => {
  const { pathname } = useLocation();
  const className = classNames(styles['tabs'], styles[variant]);

  if (routes) {
    return (
      <ul className={className}>
        {routes.map((route, index) => {
          const url = typeof route.to === 'object' ? route.to.pathname : route.to;

          const listClassNames = classNames({
            [styles['is-active']]: pathname?.includes(url) || route?.is_active,
            [styles['is-disabled']]: route?.isDisabled,
            [styles['is-locked']]: route?.is_locked,
          });

          return (
            <li className={listClassNames} data-testid={`tab-${index}`} key={`route-${index}`}>
              <Link replace to={route?.to}>
                {route?.label}
              </Link>
              {route?.is_locked && <LockIcon />}
            </li>
          );
        })}
      </ul>
    );
  }

  if (options) {
    return (
      <ul className={className}>
        {options?.map((option, index) => {
          const listClassNames = classNames({
            [styles['is-active']]: option?.value === value,
          });

          return (
            <li
              className={listClassNames}
              data-testid={`option-${index}`}
              key={`option-${index}`}
              tabIndex={0}
            >
              <span onClick={() => onChange(option?.value)}>{option?.label}</span>
            </li>
          );
        })}
      </ul>
    );
  }

  return null;
};

export default Tabs;
